export default "__VITE_ASSET__CMwWBU2c__"